import { render } from "./MatchNew.vue?vue&type=template&id=8d47ccc8"
import script from "./MatchNew.vue?vue&type=script&lang=ts"
export * from "./MatchNew.vue?vue&type=script&lang=ts"
script.render = render

export default script